import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';
import { IApiSecretKey } from '../../interfaces/IApiSecretKey';

class ApiSecretModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack',
    '$state',

  ];

  private close: any;
  private dismiss: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $modalStack: ng.ui.bootstrap.IModalStackService,
    private $state: any,
  ) {
    $scope.updateInProgress = true;
    $scope.responseArchiSmallServices = '';
    $scope.error = '';

    ArchiSmallServices.insertApiSecretKey($scope.$parent.$resolve.data).then((response) => {

      $scope.responseArchiSmallServices = JSON.parse(JSON.stringify(response)) as IApiSecretKey;
      $scope.updateInProgress = false;
    }).catch(error => {
      console.error(error);
      $scope.error = error;
      $scope.cancel();
    });

    $scope.ok = () => {
      this.close({ $value: $scope.responseArchiSmallServices });
    };

    $scope.cancel = () => {
      this.close({ $value: $scope.error });
    };

  }
}

export const ApiSecretModalComponent: ng.IComponentOptions = {
  template: require('./api-secret-modal.html'),
  controller: ApiSecretModalController,

  bindings: {
    close: '&',
    dismiss: '&'
  }
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/api-secret-modal/api-secret-modal.ts